import { z } from "zod";

export const AccountTypeSchema = z.enum(["client", "operational"]);
export type AccountType = z.infer<typeof AccountTypeSchema>;

export const StatementStatusSchema = z.enum(["pending", "processing", "processed", "error"]);
export type StatementStatus = z.infer<typeof StatementStatusSchema>;

export const StatementUploadResponseSchema = z.object({
  id: z.string().uuid(),
  account_type: AccountTypeSchema,
  statement_date: z.string().date(),
  file_name: z.string(),
  status: StatementStatusSchema,
  uploaded_at: z.string().datetime({ offset: true }),
});
export type StatementUploadResponse = z.infer<typeof StatementUploadResponseSchema>;

export const StatementStatusResponseSchema = z.object({
  id: z.string().uuid(),
  status: StatementStatusSchema,
  processed_at: z.string().datetime({ offset: true }).nullable(),
  error_message: z.string().nullable(),
});
export type StatementStatusResponse = z.infer<typeof StatementStatusResponseSchema>;
